import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import { MODAL_EVIDENCE_WARNING_UPLOAD } from 'store/modals/modals';
import CancelButton from 'shared/ui/CancelButton';
import {
  Wrapper, Header, Warning, Title, Message,
  Footer
} from './styled';

const ModalWarning = () => {
  const dispatch = useDispatch();

  useEffect(() => () => {
    dispatch(closeModal(MODAL_EVIDENCE_WARNING_UPLOAD));
  }, [dispatch]);

  const close = () => dispatch(closeModal(MODAL_EVIDENCE_WARNING_UPLOAD));

  return (
    <Wrapper>
      <Header>
        <Warning />
        <Title>Warning</Title>
      </Header>

      <Message>
        The maximum size allowed is 20MB.
      </Message>
      <Footer>
        <CancelButton onClick={ close }>Close</CancelButton>
      </Footer>
    </Wrapper>
  );
};

export default ModalWarning;
